'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { useLayoutEffect, useState } from 'react';

import { emptyValidityState, useData } from '@/components/context/data-context';
import { writeResumeSession } from '@/lib/resume-session';
import type { UserData } from '@/lib/types';

export default function FlowSessionSync({
  cid,
  initialData,
  children,
}: {
  cid: string;
  initialData: UserData;
  children?: ReactNode;
}) {
  const pathname = usePathname();
  const { data, setData, setValidity } = useData();
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    writeResumeSession({ cid, href: pathname || `/${cid}` });

    if (!data || data.immutableData.hash !== cid) {
      setData(initialData);
      setValidity(emptyValidityState);
    }

    setIsReady(true);
  }, [cid, data, initialData, pathname, setData, setValidity]);

  if (!isReady) {
    return null;
  }

  return children ?? null;
}
